<script>
  export default {
    props: ["payload", "isMobile"],
    data() {
      return {}
    },
    watch: {},
    computed: {},
    methods: {},
  };
</script>

<template>
  <div class="digital-product-label" :class="!isMobile ? 'less-margin-top' : ''">
    <div v-if="payload.digitalProductLabel == 'blueLabel'" class="blue-label px-16px py-12px">
      <img src="@/assets/icons/icon-info.svg" width="34" height="34" alt="">
      <div>
        <p class="m-0 fs-14 fw-700">Produk Digital</p>
        <p class="m-0 fs-12 fw-400 color-primary">Produk otomatis dikirimkan setelah pembayaran terkonfirmasi</p>
      </div>
      <span class="triangle-pattern-dots"></span>
    </div>
    <div v-if="payload.digitalProductLabel == 'greenLabel'" class="green-label">
      <div>
        <p class="m-0 fs-14 fw-700">Produk Digital</p>
        <p class="m-0 fs-12 fw-400 color-primary">Produk otomatis dikirimkan setelah pembayaran terkonfirmasi</p>
      </div>
      <img src="@/assets/icons/product-digital-green.svg" class="w-48px" alt="">
    </div>
  </div>
</template>
  
<style lang="scss">
  .digital-product-label {
    .blue-label {
      position: relative;
      padding: 16px 20px;
      display: flex;
      align-items: center;
      gap: 12px;
      color: #1751D0;
      background: linear-gradient(90deg,  #F5F8FD 44.97%, #D6E0F7 100%);
      border-radius: 12px;
      max-height: 80px;
      .triangle-pattern-dots {
        display: inline-block;
        mask: url("data:image/svg+xml,%3Csvg width='1em' height='1em' viewBox='0 0 52 52' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg %3E%3Ccircle cx='34' cy='34' r='2' transform='rotate(180 34 34)' fill='currentColor'/%3E%3Ccircle cx='34' cy='42' r='2' transform='rotate(180 34 42)' fill='currentColor'/%3E%3Ccircle cx='34' cy='50' r='2' transform='rotate(180 34 50)' fill='currentColor'/%3E%3Ccircle cx='42' cy='42' r='2' transform='rotate(180 42 42)' fill='currentColor'/%3E%3Ccircle cx='42' cy='50' r='2' transform='rotate(180 42 50)' fill='currentColor'/%3E%3Ccircle cx='50' cy='50' r='2' transform='rotate(180 50 50)' fill='currentColor'/%3E%3Ccircle cx='26' cy='26' r='2' transform='rotate(180 26 26)' fill='currentColor'/%3E%3Ccircle cx='26' cy='34' r='2' transform='rotate(180 26 34)' fill='currentColor'/%3E%3Ccircle cx='26' cy='42' r='2' transform='rotate(180 26 42)' fill='currentColor'/%3E%3Ccircle cx='26' cy='50' r='2' transform='rotate(180 26 50)' fill='currentColor'/%3E%3Ccircle cx='18' cy='26' r='2' transform='rotate(180 18 26)' fill='currentColor'/%3E%3Ccircle cx='18' cy='18' r='2' transform='rotate(180 18 18)' fill='currentColor'/%3E%3Ccircle cx='18' cy='34' r='2' transform='rotate(180 18 34)' fill='currentColor'/%3E%3Ccircle cx='18' cy='42' r='2' transform='rotate(180 18 42)' fill='currentColor'/%3E%3Ccircle cx='18' cy='50' r='2' transform='rotate(180 18 50)' fill='currentColor'/%3E%3Ccircle cx='10' cy='26' r='2' transform='rotate(180 10 26)' fill='currentColor'/%3E%3Ccircle cx='10' cy='18' r='2' transform='rotate(180 10 18)' fill='currentColor'/%3E%3Ccircle cx='10' cy='10' r='2' transform='rotate(180 10 10)' fill='currentColor'/%3E%3Ccircle cx='2' cy='2' r='2' transform='rotate(180 2 2)' fill='currentColor'/%3E%3Ccircle cx='10' cy='34' r='2' transform='rotate(180 10 34)' fill='currentColor'/%3E%3Ccircle cx='10' cy='42' r='2' transform='rotate(180 10 42)' fill='currentColor'/%3E%3Ccircle cx='10' cy='50' r='2' transform='rotate(180 10 50)' fill='currentColor'/%3E%3Ccircle cx='2' cy='26' r='2' transform='rotate(180 2 26)' fill='currentColor'/%3E%3Ccircle cx='2' cy='18' r='2' transform='rotate(180 2 18)' fill='currentColor'/%3E%3Ccircle cx='2' cy='10' r='2' transform='rotate(180 2 10)' fill='currentColor'/%3E%3Ccircle cx='2' cy='34' r='2' transform='rotate(180 2 34)' fill='currentColor'/%3E%3Ccircle cx='2' cy='42' r='2' transform='rotate(180 2 42)' fill='currentColor'/%3E%3Ccircle cx='2' cy='50' r='2' transform='rotate(180 2 50)' fill='currentColor'/%3E%3C/g%3E%3C/svg%3E%0A") no-repeat;
        mask-size: 100% 100%;
        background-color: currentColor;
        background-size: 100%;
        height: 1em;
        width: 1em;
        position: absolute;
        top: 5x;
        left: 281px;
        font-size: 52px;
        color: #FFFFFF;
        transform: rotate(180deg);
      }
    }

    .green-label {
      position: relative;
      padding: 16px 20px;
      display: flex;
      align-items: center;
      gap: 12px;
      color: #14AD4D;
      background: #EBFBF1;
      border-radius: 12px;
      justify-content: space-between;
      max-height: 80px;
      .w-48px {
        width: 48px;
      }
    }

    .vs-radio__label {
      width: -webkit-fill-available;
      height: 80px;
    }

    .fw-700 {
      font-weight: 700;
    }

    .fs-16 {
      font-size: 16px;
    }

    .fs-12 {
      font-size: 16px;
    }
  }
</style>